module.exports = __webpack_public_path__ + "pg.779acb73.svg";